export default {
    api: {
        baseUrl: process.env.VUE_APP_API_BASE_URL,
        baseUrlContextPattern: process.env.VUE_APP_API_BASE_URL_CONTEXT_PATTERN
    }
}
